import { Field } from 'react-final-form';
import withManualDiff from '../withManualDiff';

const FieldWithManualDiff = withManualDiff()(Field);

export default FieldWithManualDiff;
